{
  "stagePlan": {
    "title": "Stage plan",
    "help": "Each rider gets a short plan along the route. The task switches at a climb, in the last 10 km or when he is dropped.",
    "useAssistant": "Use the assistant's plan",
    "suggestion": "Assistant's suggestion",
    "suggestionReason": {
      "followLastClimb": "Saves himself and follows the best on the day's last climb. Attacking is your call.",
      "leaderFinal": "Saves himself and rides for a result in the last 10 km. Attacking is your call.",
      "ownResult": "Rides his own race for a result.",
      "breakaway": "Tries to make the break.",
      "sprintTrain": "Your sprint captain needs a train in the last 10 km.",
      "sprinter": "Saves himself for the finale.",
      "sprinterMountain": "Mountain stage: he saves himself and rides in with the grupetto.",
      "helperClimb": "Works for the captain and sets the tempo on the day's last climb.",
      "helper": "Works for the captain all day.",
      "luxuryHelper": "Luxury helper: sets the tempo for the captain on the decisive climb."
    },
    "noPlan": "No plan yet. He rides on his role.",
    "noPlanLocked": "No plan. He rode on his role.",
    "noPlanOrders": "No plan yet. He rides on what you set: {orders}.",
    "noPlanOrdersLocked": "No plan. He rode on what you set: {orders}.",
    "luxuryHelperPlan": "No saved plan. As luxury helper he rides the suggestion.",
    "luxuryHelperPlanLocked": "No saved plan. As luxury helper he rode the suggestion.",
    "noFit": "This plan no longer fits his role. Pick a new one.",
    "colPlan": "Plan for stage {number}",
    "colPlanRaceDay": "Plan for the race",
    "change": "Change",
    "setPlan": "Set plan",
    "close": "Close",
    "tapToEdit": "Tap to change",
    "editTitle": "Plan for {name}",
    "stepLabel": "Step {number}",
    "taskLabel": "Task",
    "switchLabel": "Switch",
    "addStep": "Add a step",
    "removeStepAria": "Remove step {number} for {name}",
    "useSuggestion": "Use the suggestion",
    "clearPlan": "Remove the plan",
    "effortNote": "The effort follows the task.",
    "rulesNote": "The break can only be the first task. Grupetto, riding in and the sprint train always come last.",
    "switchNote": {
      "climb": {
        "start": "The last 10 km start on a climb here, so step {number} begins at the foot of it.",
        "end": "The last 10 km start on a climb here, so step {number} begins at the top.",
        "finale": "The last 10 km start on the final climb here, so step {number} only begins in the finale."
      },
      "sector": {
        "start": "The last 10 km start on a sector here, so step {number} begins where the sector starts.",
        "end": "The last 10 km start on a sector here, so step {number} begins where the sector ends.",
        "finale": "The last 10 km start on the final sector here, so step {number} only begins in the finale."
      },
      "descent": {
        "start": "The last 10 km start on the descent to the finish, so step {number} begins at the top.",
        "end": "The last 10 km start on the descent to the finish, so step {number} only begins in the finale.",
        "finale": "The last 10 km start on the descent to the finish, so step {number} only begins in the finale."
      },
      "samePoint": "Steps {first} and {second} switch at the same point here, so step {first} is not ridden."
    },
    "timeTrial": "No stage plan on a time trial.",
    "task": {
      "breakaway": "Go in the break",
      "stay_sheltered": "Stay sheltered",
      "shelter_leader": "Keep the leader up front",
      "tempo": "Set the tempo",
      "follow_moves": "Follow the moves",
      "attack": "Attack",
      "ride_for_result": "Ride for a result",
      "sprint_train": "Sprint train",
      "grupetto": "Grupetto",
      "ride_in": "Ride to the finish"
    },
    "from": {
      "kom": "after {climb}",
      "final_km": "last 10 km",
      "dropped": "when dropped",
      "caught": "when caught"
    },
    "climbFallback": "cat. {category} climb",
    "recap": {
      "title": "What he did",
      "kom": "until the top of {climb}",
      "final_km": "until the last 10 km",
      "dropped": "until he was dropped at km {km}",
      "caught": "until he was caught at km {km}",
      "missed_break": "did not make the break",
      "finish": "to the finish",
      "abandoned": "abandoned at km {km}",
      "skipped": "skipped, he was dropped before",
      "notReached": "not reached",
      "pending": "The race film for this stage is not ready yet."
    }
  },
  "stagePageV2": {
    "tabsAria": "Race views",
    "tab": { "stage": "Stage", "standings": "Standings", "team": "Team", "tactics": "Tactics" },
    "stripAria": "Stages",
    "stripStage": "Stage {number}",
    "today": "Today",
    "stripResult": "{name} #{rank}",
    "stripRidden": "Finished",
    "profile": {
      "title": "Stage {number} · the route",
      "titleOneDay": "The route",
      "stats": "{km} km · {gain} m climbing · {climbs, plural, one {# climb} other {# climbs}}",
      "aria": "Stage profile, {km} km, coloured by gradient.",
      "tipToGo": "{km} km to go",
      "tipToTop": "{km} km to the top of {name}",
      "finish": "Finish · {m} m",
      "toGoAxis": "{km} km to go",
      "drawn": "Drawn from the climbs and the total climbing. Gradients between the climbs are approximate.",
      "legend": { "flat": "under 3 %", "band2": "3-6 %", "band3": "6-8 %", "band4": "8-10 %", "band5": "over 10 %", "down": "downhill" },
      "sprint": "Sprint km {km}"
    },
    "axes": {
      "terrain": "Terrain",
      "finish": "Finish",
      "surface": "Surface",
      "surfaceValue": "{kind, select, gravel {Gravel} other {Cobbles}} · {count, plural, one {# sector} other {# sectors}}, {km} km",
      "weather": "Weather"
    },
    "weather": {
      "dry": "Dry",
      "rain": "Rain",
      "wind": "Wind",
      "aria": "Weather: {word}",
      "mattered": {
        "rain": "The rain hit riders with weak descending and durability hardest.",
        "wind": "The wind on the open roads hit riders with weak descending and durability hardest."
      }
    },
    "climbs": {
      "title": "The climbs",
      "hint": "Tap a climb on the profile or here",
      "length": "Length",
      "average": "Average",
      "steepest": "Steepest km",
      "hardest5": "Hardest 5 km",
      "top": "Top",
      "steepestValue": "{grade} % · km {index}",
      "topValue": "{m} m · km {km}",
      "toFinish": "To the finish",
      "perKmAria": "{name}, gradient per kilometre",
      "noPerKm": "Kilometre-by-kilometre gradients come with the real stage profile.",
      "none": "No categorised climbs on this stage."
    },
    "demands": { "title": "The day demands", "decides": "Decides it", "matters": "Matters", "helps": "Helps" },
    "lineup": {
      "title": "Your line-up",
      "fit": "Route fit",
      "fitAria": "Route fit {fit} of 100",
      "empty": "You have no riders in this race."
    },
    "cta": {
      "setTactics": "Set tactics for stage {number} · {done} of {total} done",
      "setTacticsLocks": "Set tactics for stage {number} · {done} of {total} done · locks {time}",
      "setTacticsOneDay": "Set tactics · {done} of {total} done",
      "fullResult": "Full result"
    },
    "favourites": {
      "title": "Favourites",
      "foot": "Follows the stage profile, from results in this race so far. Route fit only for your own riders.",
      "leadsOverall": "Leads the overall",
      "overall": "#{rank} overall, {gap}",
      "wonStage": "Won stage {number}",
      "placed": {
        "flat": "Top 10 on {count, plural, one {# flat stage} other {# flat stages}}",
        "hilly": "Top 10 on {count, plural, one {# hilly stage} other {# hilly stages}}",
        "mountain": "Top 10 on {count, plural, one {# mountain stage} other {# mountain stages}}",
        "itt": "Top 10 on {count, plural, one {# time trial} other {# time trials}}"
      },
      "you": "You"
    },
    "story": {
      "title": "How stage {number} was raced",
      "titleOneDay": "How the race played out",
      "hudOneDay": "Race",
      "viewsAria": "Profile view",
      "view": {
        "route": "The route",
        "stage": "Whole stage",
        "race": "Whole race",
        "final": "Final 5 km"
      },
      "noFinal": "Final 5 km needs exact times in the race log. This stage was raced before they were logged, so it shows places in km only.",
      "timeTrial": "Time trial: every rider rides alone, so there is no group story. The times are in the result.",
      "you": "You",
      "aRider": "A rider",
      "kmAt": "km {km}",
      "kmSpan": "km {from}-{to}",
      "unfolded": "How it unfolded",
      "source": "Every time, gap and sentence here comes from this stage's race log.",
      "replay": {
        "play": "Play the stage",
        "pause": "Pause",
        "scrubAria": "Replay position in km",
        "positionTime": "km {km} · {time}"
      },
      "group": {
        "leads": "Leads",
        "peloton": "Peloton",
        "riders": "{count, plural, one {# rider} other {# riders}}",
        "rest": "{groups, plural, one {# more group} other {# more groups}} · {riders, plural, one {# rider} other {# riders}} · +{min} to +{max}"
      },
      "line": {
        "formed": "{count, plural, one {# rider goes clear} other {# riders go clear}}",
        "caught": "{count, plural, one {# rider from the break is caught} other {# riders from the break are caught}}",
        "survived": "The break stays away to the finish",
        "attack": "{count, plural, one {{names} attacks} other {{names} attack}}",
        "attackGain": "{count, plural, one {{names} attacks and gains {gain}} other {{names} attack and gain {gain}}}",
        "attackAnon": "A late attack",
        "incident": "{name} {kind, select, crash {crashes} mechanical {has a mechanical} other {has an incident}}{outcome, select, abandoned { and abandons} loss { and loses {loss}} other {}}",
        "climb": "Top of {name}",
        "climbFirst": "{rider} first over {name}",
        "gap": "The gap to {group, select, rest {the peloton} other {the chase}} {dir, select, grew {grows} other {shrinks}} from {before} to {after}",
        "split": "{count, plural, one {A group splits off} other {# groups split off}}",
        "dropped": "{count, plural, one {{names} is dropped from the break} other {{names} are dropped from the break}}",
        "formedAhead": "{count, plural, one {# rider goes clear ahead of the peloton} other {# riders go clear ahead of the peloton}}",
        "caughtAhead": "{count, plural, one {# rider from the group ahead of the peloton is caught} other {# riders from the group ahead of the peloton are caught}}",
        "survivedAhead": "The group ahead of the peloton stays away to the finish",
        "droppedAhead": "{count, plural, one {{names} is dropped from the group ahead of the peloton} other {{names} are dropped from the group ahead of the peloton}}",
        "joined": "{count, plural, one {Two groups come together} other {Groups come together # times}}",
        "gcLead": "{name} takes the overall lead",
        "crack": "{name} cracks",
        "finish": "{name} wins",
        "finishSprint": "{name} wins the sprint",
        "finishAnon": "Finish"
      },
      "splits": {
        "title": "Split times",
        "point": "Point",
        "leaderTime": "Leader",
        "leading": "Leading",
        "first": "First over",
        "top": "Top {name}",
        "topOfPlace": "Top of {place}",
        "climb": "climb",
        "sprint": "Intermediate sprint",
        "finish": "Finish",
        "none": "No climbs, sprints or finish in the race log."
      },
      "report": {
        "title": "Report",
        "formed": "{count, plural, one {# rider went clear} other {# riders went clear}} at km {km}.",
        "formedMine": "{count, plural, one {# rider went clear} other {# riders went clear}} at km {km}, with your {mine}.",
        "caught": "The break was caught by km {km}.",
        "survived": "{names} stayed away to the finish.",
        "attack": "{names} attacked at km {km}.",
        "attackGain": "{names} attacked at km {km} and gained {gain} on the bunch.",
        "winner": "{winner} won.",
        "winnerGap": "{winner} won, {gap} ahead of {second}.",
        "winnerSame": "{winner} won ahead of {second} on the same time.",
        "mine": "Your best was {name}, #{rank}.",
        "mineGap": "Your best was {name}, #{rank}, {gap} down.",
        "mineWon": "Your rider {name} won.",
        "climb": "The race went over {name} at km {km}.",
        "climbFirst": "{rider} was first over {name}.",
        "sameTime": "{count} riders finished on the winner's time.",
        "third": "{name} was third.",
        "thirdGap": "{name} was third, {gap} down.",
        "placed": "{name} finished in position {rank}.",
        "placedGap": "{name} finished in position {rank}, {gap} down."
      },
      "final": {
        "aria": "The final 5 km: groups on the road with distance to go, gaps and race clock",
        "toGoKm": "{km} KM",
        "toGoM": "{m} M",
        "finish": "FINISH",
        "winningTime": "Winning time",
        "speed": "{kmh} km/h",
        "back": "{label} · {dist} km back",
        "gaps": "Gaps",
        "gapsFoot": "Gap in seconds at the leader's position, from the race log.",
        "finished": "Finished",
        "behindMark": "Behind the 5 km mark",
        "closeUp": "Sprint close-up",
        "closeUpOpens": "Opens at 500 m to go",
        "closeUpHint": "The close-up follows the front from 500 m to go.",
        "closeUpDone": "Result",
        "play": "Play the final 5 km",
        "scrubAria": "Race time in the final 5 km",
        "speedAria": "Playback speed"
      }
    },
    "yourDay": {
      "title": "Your day · stage {number}",
      "titleOneDay": "Your day",
      "classAria": "Classification",
      "stage": "Stage",
      "overall": "Overall",
      "topN": "Top {count}",
      "yourRiders": "Your riders",
      "noRiders": "None of your riders are in this result.",
      "bestOverall": "Your best overall",
      "bestOverallGap": "{name} · {gap} to {leader}",
      "bestOverallLeads": "{name} leads the race",
      "whyGap": "{winner} won, {gap} ahead of {second}.",
      "whySame": "{winner} won ahead of {second} on the same time.",
      "mineLine": "Your best was {name}, #{rank}, {gap} down.",
      "mineWon": "Your rider {name} won the stage."
    }
  },
  "hub": {
    "title": "Planning",
    "tabSelection": "Team selection",
    "tabForm": "Form plan",
    "tabStrategy": "Strategy",
    "tabCalendar": "Calendar"
  },
  "seasonView": {
    "toggleSeason": "Season",
    "toggleDay": "Day",
    "meta": "Season {season} · {division} · {count, plural, one {# race} other {# races}} · {start} – {end}",
    "divisionLabel": "Division {n}",
    "hint": "Pick a race day to open its board",
    "today": "TODAY",
    "stagesGt": "{count} stages · GT",
    "stagesOnly": "{count} stages",
    "monument": "Monument · exclusive race day",
    "bandAria": "{name}, day {day} of {total}. Open its day board.",
    "dayPanel": {
      "title": "Day {day} of {total} · {date}",
      "meta": "{races, plural, one {# race} other {# races}} · {saved, plural, one {# selection saved} other {# selections saved}} · {open} open",
      "openBoard": "Open day board"
    },
    "legend": {
      "label": "LEGEND",
      "gt": "Grand Tour",
      "monument": "Monument, exclusive race day",
      "selected": "You have a selection",
      "none": "No selection yet"
    },
    "empty": "No races on the calendar yet",
    "error": "Nothing was lost. This view is read-only.",
    "errorSession": "Your session has ended. Sign in again to keep planning.",
    "retry": "Try again",
    "picker": {
      "ariaLabel": "Season",
      "current": "Season {number} (current)",
      "upcoming": "Season {number} (upcoming)",
      "previous": "Season {number} (previous)"
    },
    "startsOn": "Starts {date}",
    "readOnlyHint": "Read-only preview. Editing opens automatically once this season becomes active.",
    "changeover": {
      "title": "What changes at season changeover",
      "items": {
        "age": "Riders age +1",
        "form": "Form decays toward 50 (about 25% carries over)",
        "fatigue": "Fatigue resets to 0",
        "injuries": "Injuries are not reset",
        "peaks": "Peak plans stay unchanged",
        "wages": "Wages and rider values update Sunday"
      },
      "firstRaceDay": "Racing starts the day after the changeover, at least 24 hours after the old season's last race.",
      "readMore": "Full details in Help"
    },
    "errorTitle": "Season calendar could not be loaded"
  },
  "matrix": {
    "heading": "Selection matrix",
    "mobile": {
      "raceLabel": "Race",
      "riderLabel": "Rider",
      "earlier": "Earlier",
      "later": "Later",
      "windowStatus": "Days {first}-{last} of {total}",
      "gameDay": "Day {day}"
    },
    "lens": {
      "entries": "Entries",
      "routeMatch": "Route match",
      "formPeak": "Form & peak",
      "load": "Load"
    },
    "problemsOnly": "Problems only",
    "save": "Save plan",
    "saveCount": "{count, plural, one {Save plan · # change} other {Save plan · # changes}}",
    "saving": "Saving...",
    "saveErrorNamed": "Couldn't save {race}: {reason}",
    "noProblems": "No problems",
    "problemsCount": "{count, plural, one {# problem} other {# problems}}",
    "leaveUnsaved": "You have unsaved changes in the matrix. Leave anyway?",
    "errorTitle": "Selection matrix could not be loaded",
    "empty": "No races this season yet",
    "restDay": "Rest day",
    "withdrawnHint": "Saving a new line-up cancels your withdrawal and replaces the old selection.",
    "dayAria": "Race day {index}, {date}. Open its day board.",
    "cellEmptyAria": "{rider}, {race}: not selected. Click to add.",
    "cellFilledAria": "{rider}, {race}: {role}. Click to change.",
    "squadCount": "{count}/{max}",
    "loadSuffix": "{count, plural, one {# race day} other {# race days}}",
    "peakWindow": "Peak window · targeting {race}",
    "peakWindowNoTarget": "Peak window",
    "peakLocked": "locked",
    "backToMatrix": "Back to season matrix",
    "cellPopover": {
      "roleChoice": "Role",
      "remove": "Remove from race"
    }
  },
  "racehub": {
    "error": {
      "title": "Team selection could not be loaded",
      "body": "Nothing was lost. Your line-ups are safe.",
      "parse": "The race board could not be loaded. Please reload the page.",
      "session": "Your session has ended. Sign in again to keep planning.",
      "retry": "Try again"
    },
    "scope": {
      "mine": "My races",
      "division": "My division",
      "others": "Other divisions",
      "soon": "Coming soon"
    },
    "timeline": {
      "dayOf": "Day {day} of {total}",
      "youAreHere": "you are here",
      "prev": "Previous day",
      "next": "Next day"
    },
    "heading": "Squad distribution",
    "overlap": "{count} races today",
    "raceDay": "Race day {day}",
    "raceDays": "Race days {start}-{end}",
    "sameDayNote": "Same real day, different race days. A rider can ride one race per race day.",
    "learnReuse": {
      "title": "Reusing a rider across race days",
      "body": "These races share one afternoon but fall on different in-game race days, so a rider can ride both. He carries fatigue into the later race. That is a trade-off, not a bug.",
      "dismiss": "Got it"
    },
    "save": "Save changes",
    "discard": "Discard",
    "unsaved": "You have unsaved changes",
    "leaveUnsaved": "You have unsaved changes. Leave without saving?",
    "status": {
      "full": "{selected} / {target} selected",
      "understaffed": "{selected} / {target} · understaffed",
      "overfull": "{selected} / {target} · too many",
      "withdrawn": "Withdrawn",
      "locked": "Lineup locked",
      "didNotStart": "Did not start"
    },
    "pool": {
      "title": "Available riders · {count}-squad",
      "autofill": "Auto-fill",
      "fillMissing": "Fill gaps",
      "clearDay": "Clear day",
      "clearAllSeason": "Clear all",
      "bound": "Locked riders cannot be added to any race shown today",
      "loadShort": "{days}d",
      "loadTitle": "Season load: {races, plural, one {# race} other {# races}}, {days, plural, one {# race day} other {# race days}} entered this season",
      "clearDayTooltip": "Clears {races, plural, one {# race} other {# races}} and removes {riders, plural, one {# rider} other {# riders}} for this day"
    },
    "clearDayWarn": "Remove {riders, plural, one {# rider} other {# riders}} from {races, plural, one {# race} other {# races}} today? This cannot be undone, and the assistant will not refill them until you ask it to.",
    "clearAllWarn": "Remove every rider from ALL your remaining races this season? This cannot be undone, and the assistant will not refill them until you ask it to.",
    "clearAllDialog": {
      "title": "Clear all selections?",
      "body": "A race you have no squad for is a race your team does not start. This removes your riders from {count, plural, one {1 race} other {# races}}.",
      "startsIn": "starts in {time}",
      "reassurance": "You can pick a new squad at any time before a race starts.",
      "keepSquad": "Keep my squad",
      "clearAnyway": "Clear anyway"
    },
    "column": {
      "riderHeading": "Rider",
      "orderHeading": "Order",
      "helperOrder": "Domestique",
      "editOrder": "{order}: change order for {name}",
      "routeMatchHeading": "Route match",
      "currentFormHeading": "Current form",
      "numbersExplanation": "Route match: average for the whole race across its stages. Current form: today's form, not a forecast. A dash means unavailable.",
      "add": "Add from available",
      "withdraw": "Withdraw",
      "reenter": "Re-enter",
      "withdrawnNote": "Your team is voluntarily not starting this race",
      "didNotStartNote": "Your team did not start: fewer than {min} fit riders at the start.",
      "remove": "Remove rider",
      "openRace": "Open {name}",
      "peaksHere": "Peaking here: {names}",
      "paybackHere": "Payback dip here: {names} ({points} form)",
      "paybackHereNoPoints": "Payback dip here: {names}",
      "clearSelection": "Clear selection",
      "sharesDay": "Shares race day {day} with {race}",
      "sharesDays": "Shares race days {start}-{end} with {race}",
      "sharesMany": "Shares race days with {count, plural, one {# other race} other {# other races}}",
      "sharesItem": "Race day {day} · {race}",
      "sharesItemDays": "Race days {start}-{end} · {race}",
      "clash": "{rider} rides both on race day {day}",
      "clashMany": "{count, plural, one {# rider rides} other {# riders ride}} more than one race on the same day"
    },
    "popover": {
      "title": "Add to which race?",
      "none": "No race available for this rider today",
      "understaffed": "needs riders",
      "availableGroup": "Available for",
      "blockedGroup": "Busy in an overlapping race",
      "blockedReason": "Overlaps {race}",
      "compatibleHint": "Same day as {race}, race day {day}. Can ride both.",
      "compatibleHintNoDay": "Same day as {race}. Can ride both."
    },
    "role": {
      "hint": "Tap an order to change the rider's role",
      "captain": "Captain",
      "sprintCaptain": "Sprint captain",
      "coCaptain": "Shared captain",
      "luxuryHelper": "Luxury helper",
      "hunter": "Breakaway hunter",
      "rider": "Rider only"
    },
    "roleCard": {
      "heading": "Tactics",
      "subhead": "Give each rider a job. The hint shows why the role fits this terrain.",
      "captain": {
        "title": "Captain",
        "hint": {
          "flat": "Your protected leader. The team rides to deliver them to the flat finish.",
          "hilly": "Your protected leader on the climbs. The team shelters them to the hilly finish.",
          "mountain": "Your protected leader in the mountains. The team paces them to the summit.",
          "cobbles": "Your protected leader over the cobbles. The team keeps them out of trouble.",
          "itt": "The rider you back for the time trial. No team support applies here."
        }
      },
      "sprint_captain": {
        "title": "Sprint captain",
        "hint": {
          "flat": "Your finisher for a bunch sprint. The team leads them out on the flat.",
          "hilly": "Your finisher if the hills end in a reduced sprint.",
          "mountain": "Sprints rarely decide a mountain stage. Useful only for an early sprint.",
          "cobbles": "Your finisher if the cobbles come back together for a sprint.",
          "itt": "A sprint role has no effect in a time trial."
        }
      },
      "hunter": {
        "title": "Breakaway hunter",
        "hint": {
          "flat": "Sends this rider up the road. On flat finishes a breakaway can stay away.",
          "hilly": "Sends this rider on the attack. Hilly finales reward a hunter.",
          "mountain": "Sends this rider clear. A mountain breakaway can hold to the line.",
          "cobbles": "Sends this rider into the cobbled break. It can stick to the finish.",
          "itt": "There is no breakaway in a time trial."
        }
      },
      "rider": {
        "title": "Rider only",
        "hint": {
          "flat": "No special role. Rides in support of your captain and sprinter.",
          "hilly": "No special role. Rides in support on the climbs.",
          "mountain": "No special role. Paces and protects your leader in the mountains.",
          "cobbles": "No special role. Helps position your leaders over the cobbles.",
          "itt": "No special role. Each rider races the time trial alone."
        }
      },
      "free_role": {
        "title": "Free role",
        "hint": {
          "flat": "Rides their own race on the flat. No team duties, no captain support.",
          "hilly": "Rides their own race on the climbs. No team duties, no captain support.",
          "mountain": "Rides their own race in the mountains. No team duties, no captain support.",
          "cobbles": "Rides their own race over the cobbles. No team duties, no captain support.",
          "itt": "Rides their own race in the time trial. No team duties, no captain support."
        }
      }
    },
    "hunterExplainer": {
      "dayLine": "Your hunter tries to get into the morning breakaway. Whether it stays away is decided by the peloton on the day.",
      "outlook": {
        "about": "Engine forecast: the breakaway stays away about {k} in {n} times.",
        "under": "Engine forecast: the breakaway stays away less than {k} in {n} times.",
        "over": "Engine forecast: the breakaway stays away more than {k} in {n} times.",
        "stage": "Stage {stage}",
        "reason": {
          "nobodyChases": "Few teams have a reason to chase it.",
          "fewChase": "One or two teams usually have a reason to chase it.",
          "manyChase": "Several teams usually have a reason to chase it."
        }
      },
      "candidatesHint": "Ranked by aggression: the urge to attack and commit to a move.",
      "noCandidates": "Pick riders for this race to see your best hunters.",
      "aggression": "Aggression",
      "pickTitle": "Pick your breakaway hunter",
      "noHunter": "No hunter"
    },
    "fit": {
      "label": "Fit",
      "strong": "Strong",
      "average": "Average",
      "poor": "Poor"
    },
    "boundNamed": "Locked · racing in {race}",
    "lockBoundUnnamed": "Locked · already racing in an overlapping race",
    "outgoingShort": "Leaves after this race",
    "lockOutgoing": "Leaves after the current race · cannot be picked for a new one",
    "lockAllStarted": "Locked · every race today has already started",
    "lockAllWithdrawn": "Locked · you have withdrawn from every race today",
    "lockUnavailable": "Locked · no race today can be changed",
    "lineupLocked": {
      "title": "Lineup locked",
      "note": "This race has started. The lineup is final."
    },
    "dismiss": "Dismiss",
    "empty": "No races to plan for this day.",
    "regenerateWarn": "This replaces every pick on today's races with the assistant's suggestion. Continue?"
  },
  "tabs": {
    "library": "Library",
    "world": "World calendar"
  },
  "raceType": {
    "stageRace": "Stage race",
    "oneDay": "One-day race",
    "oneDayShort": "One-day",
    "stages": "{count, plural, one {# stage} other {# stages}}",
    "stageRaceWithStages": "Stage race · {count, plural, one {# stage} other {# stages}}",
    "stageRaceParen": "Stage race ({count})"
  },
  "classOption": {
    "TourFrance": "Grand Tour",
    "GiroVuelta": "Major Tour",
    "Monuments": "Monuments",
    "OtherWorldTourA": "WorldTour A",
    "OtherWorldTourB": "WorldTour B",
    "OtherWorldTourC": "WorldTour C",
    "ProSeries": "ProSeries",
    "Class1": "Class 1",
    "Class2": "Class 2"
  },
  "classBadge": {
    "grandTour": "Grand Tour",
    "oneDay": "One-day",
    "worldTour": "WorldTour",
    "continental": "Continental"
  },
  "status": {
    "completed": "Completed",
    "active": "Live",
    "live": "Live",
    "scheduled": "Upcoming"
  },
  "liveProgress": "Stage {done} / {total}",
  "common": {
    "free": "Free",
    "dash": "—",
    "loading": "Loading…",
    "points": "{count} pt"
  },
  "empty": {
    "noRacesMatch": "No races match the filters",
    "raceNotFound": "Race not found",
    "noResultsImportedRace": "No results imported for this race yet",
    "noHistory": "No data found for \"{name}\"",
    "raceNotFoundHint": "The link may be old, or the race was removed. Open the race library to find another one.",
    "noResultsImportedRaceHint": "This race has no result rows yet. Other races in the library already have theirs.",
    "noResultsImportedRaceCta": "Open the race library",
    "notStartedRace": "The race has not started yet",
    "notStartedStageRaceHint": "Standings appear once stage 1 has been ridden.",
    "notStartedOneDayHint": "Results appear once the race has been ridden."
  },
  "calendar": {
    "upcoming": "Upcoming",
    "completed": "Completed",
    "resultsImported": "{count} results imported",
    "expectedPool": "Expected pool {amount}",
    "expectedPoolTooltip": "Live-calculated expected pool based on race class × race type × stages",
    "selectPrompt": "Select a race to see details",
    "noResultsYet": "No results imported yet",
    "viewFull": "View full results",
    "viewFullWithStages": "View full results + all stages"
  },
  "library": {
    "searchLabel": "Search races",
    "searchPlaceholder": "Klassiker, Gran Premio, Trofeo…",
    "seasonLabel": "Season",
    "allSeasons": "All seasons",
    "seasonOption": "Season {number}",
    "seasonOptionActive": "Season {number} (active)",
    "classLabel": "Class",
    "allClasses": "All classes",
    "statusLabel": "Status",
    "allStatuses": "All",
    "myDivisionOnly": "My division only",
    "filteredCount": "{filtered} of {total} races",
    "clearFilters": "Clear filters",
    "thRace": "Race",
    "thSeason": "Season",
    "thClass": "Class",
    "thType": "Type",
    "thStatus": "Status",
    "seasonLink": "Season {number}"
  },
  "world": {
    "loading": "Loading world calendar…",
    "totalRaces": "{count} races in total across the world calendar",
    "classSummary": "{count} races · {stages} stages",
    "filteredOn": "Filtered on {class}.",
    "clearFilter": "Clear filter",
    "thRace": "Race",
    "thClass": "Class",
    "thType": "Type",
    "thStages": "Stages"
  },
  "resultType": {
    "stage": "Stage",
    "gc": "Overall",
    "points": "Points",
    "mountain": "Mountains",
    "young": "Youth"
  },
  "points": {
    "loadError": "Couldn't load the points table. Please try again.",
    "retry": "Try again",
    "subtitle": "How your race prizes are calculated from your placements",
    "help": "Help & Rules",
    "formula": "Prize formula: 1 point = {amount} CZ$",
    "noClassData": "No points data for this class",
    "thRank": "Rank",
    "thPoints": "Points",
    "thPrize": "Prize",
    "showLess": "Hide",
    "showAll": "Show all {count} ranks",
    "prizeExample": {
      "tourWin": "Grand Tour win",
      "monumentWin": "Monument win",
      "tourStageWin": "Stage win (Grand Tour)",
      "proSeriesWin": "ProSeries win",
      "class1Win": "Class 1 win",
      "class2Win": "Class 2 win"
    },
    "type": {
      "Klassement": {
        "label": "General classification",
        "desc": "GC placement in stage races"
      },
      "Klassiker": {
        "label": "Classics",
        "desc": "Overall placement in one-day races"
      },
      "Etapeplacering": {
        "label": "Stage placement",
        "desc": "Per stage in stage races"
      },
      "Pointtroje": {
        "label": "Points jersey",
        "desc": "Top 3 in the points competition"
      },
      "Bjergtroje": {
        "label": "Mountains jersey",
        "desc": "Top 3 in the mountains competition"
      },
      "Ungdomstroje": {
        "label": "Young rider jersey",
        "desc": "Top 3 in the U25 competition"
      },
      "EtapelobHold": {
        "label": "Team (stage race)",
        "desc": "Best team in stage races"
      },
      "KlassikerHold": {
        "label": "Team (classic)",
        "desc": "Best team in classics"
      },
      "Forertroje": {
        "label": "Leader's jersey",
        "desc": "Per day in the leader's jersey"
      },
      "PointtrojeDag": {
        "label": "Points jersey (per day)",
        "desc": "Per day in the points jersey"
      },
      "BjergtrojeDag": {
        "label": "Mountains jersey (per day)",
        "desc": "Per day in the mountains jersey"
      },
      "UngdomstrojeDag": {
        "label": "Young rider jersey (per day)",
        "desc": "Per day in the young rider jersey"
      }
    }
  },
  "selection": {
    "title": "Team selection",
    "subtitle": "Pick up to {max} riders for this race. You can save a partial team, and your assistant fields the rest when the race runs. No penalty.",
    "count": "{count}/{max} selected",
    "partialHint": "{open, plural, one {1 spot open. Your assistant fills it when the race runs.} other {# spots open. Your assistant fills them when the race runs.}}",
    "partialHintShort": "{open, plural, one {1 spot open} other {# spots open}}, {free, plural, one {1 rider free} other {# riders free}} for this race. Your assistant fills what it can.",
    "assistantFillsEmpty": "No riders selected. Your assistant picks the squad when the race runs.",
    "willNotStart": "Fewer than {min} riders. Your team will not start this race.",
    "willNotStartEmpty": "Fewer than {min} riders free for this race. Your team will not start.",
    "willNotStartShort": "Under {min} riders. Does not start.",
    "startsShort": "{injured, plural, one {1 selected rider is injured} other {# selected riders are injured}}. Your team starts with {starters, plural, one {1 rider} other {# riders}}.",
    "startsShortShort": "Injuries: starts with {starters}.",
    "minHint": "Minimum {min} riders to start.",
    "captain": "Captain",
    "sprintCaptain": "Sprint captain (optional)",
    "coCaptain": "Shared captain (optional)",
    "coCaptainHint": "Protected like the captain. The captain gets help first.",
    "luxuryHelper": "Luxury helper (optional)",
    "luxuryHelperHint": "Saves himself, then works for the captain on the decisive climb.",
    "hunter": "Breakaway hunter",
    "freeRole": "Free role",
    "noRole": "None",
    "thRider": "Rider",
    "type": "Type",
    "mode": {
      "current": "Current",
      "abilities": "Abilities"
    },
    "suitabilityHelp": "Suitability (0-100) rates how well a rider fits this race's terrain. Higher is a better match.",
    "hideInjured": "Hide injured",
    "suitability": "Suitability",
    "routeMatch": "Route match",
    "riderProfile": {
      "viewProfile": "View {name}'s profile",
      "aggression": "Aggression",
      "tactics": "Tactics",
      "hint": "Closing this does not change your selection. Use the checkbox to select or deselect this rider."
    },
    "driverInsight": {
      "escape": {
        "high": "Escape chance: High. Aggression pulls him into breakaway attempts often on this terrain, and it never costs his own result if the move gets caught.",
        "medium": "Escape chance: Medium. Aggression occasionally pulls him into breakaway attempts on this terrain, with no cost if the move gets caught.",
        "low": "Escape chance: Low. Not aggressive enough to be a regular breakaway threat on this terrain."
      },
      "tactics": {
        "strong": "Tactical fit: Strong. This stage rewards positioning and race-reading, and that's a strength of his.",
        "average": "Tactical fit: Average. This stage rewards positioning and race-reading.",
        "poor": "Tactical fit: Limited. This stage rewards positioning and race-reading, which isn't his strength yet."
      }
    },
    "sort": {
      "label": "Sort by",
      "ascAria": "Sorting ascending, tap for descending",
      "descAria": "Sorting descending, tap for ascending"
    },
    "best": "Best",
    "bestForStage": "Your strongest fit for this stage",
    "whyBest": "This {bucket} stage rewards your strongest fit: {name}.",
    "form": "Form",
    "fatigue": "Fatigue",
    "doctor": {
      "label": "Doctor",
      "hint": "Your team doctor's read on each rider. A better medical department gives a sharper read.",
      "assessment": {
        "fresh": "Fresh",
        "ready": "Good to go",
        "tired": "Tired",
        "rest": "Needs rest",
        "injured": "Injured"
      },
      "season": {
        "ready": "Ready for this one and the rest of the season.",
        "ready_but_spent_later": "Ready now, but running on empty by the third Grand Tour.",
        "already_heavy": "Has raced a lot this season. Every stage costs more now.",
        "rest_first": "Give him rest before this one."
      }
    },
    "injured": "Injured",
    "overAge": "Over age limit",
    "boundIn": "Riding {race}",
    "boundConflict": "Overlaps {race}",
    "autoPicked": "Assistant's pick. Adjust and save to take control.",
    "draftRestored": "I kept your unsaved picks. Save them before the flag drops.",
    "autoFill": "Auto-select",
    "autoFillError": "Could not auto-select. Try again.",
    "autoFillReloadFailed": "Auto-select saved your squad, but reloading it here failed. Retry before you make more changes.",
    "retry": "Try again",
    "save": "Save selection",
    "saveLocked": "Save selection (locked)",
    "trainNowLock": {
      "title": "Locked today.",
      "bodyAt": "You pressed Train now at {time}. Riders who trained today can't race today's race.",
      "body": "Riders who trained today can't race today's race.",
      "rider": "Trained today",
      "columnLocked": "Locked"
    },
    "saving": "Saving…",
    "saved": "Selection saved.",
    "wrongPool": {
      "title": "This race is in another division",
      "note": "You can only enter races in your own division, so there's no line-up to set here."
    },
    "rejoinNote": "Saving a new line-up cancels your withdrawal and replaces the old selection.",
    "withdrawnPanel": {
      "title": "You have withdrawn from this race",
      "note": "Your team is voluntarily not starting, so there is no line-up to set. Re-enter from the race board if you change your mind before the start.",
      "keptHeading": "{count, plural, one {# rider kept for a re-entry} other {# riders kept for a re-entry}}"
    },
    "errors": {
      "selection_wrong_size": "You can pick at most {max} riders.",
      "move_target_full": "That race is already full. Remove a rider there first.",
      "move_target_locked": "That race has started, so its lineup is locked.",
      "move_wrong_pool": "You can only enter races in your own division.",
      "move_rider_ineligible": "That rider can't race for your team right now.",
      "move_invalid_body": "Couldn't move the rider. Try again.",
      "move_failed": "Couldn't move the rider. Try again.",
      "selection_captain_required": "Pick a captain among your selected riders.",
      "selection_captain_not_selected": "Your captain must be one of the selected riders.",
      "selection_co_captain_not_available": "Shared captain isn't available in this race.",
      "selection_co_captain_requires_captain": "A shared captain needs a captain. Pick a captain first.",
      "selection_role_not_selected": "Role riders must be part of the selection.",
      "selection_role_overlap": "Captain, sprint captain and hunter must be different riders.",
      "selection_luxury_helper_not_available": "Luxury helper isn't available in this race.",
      "selection_rider_injured": "Injured riders can't be selected.",
      "selection_rider_over_age": "Riders over the race's age limit can't be selected.",
      "selection_rider_not_on_team": "You can only select your own riders.",
      "selection_duplicate_rider": "Each rider can only be selected once.",
      "selection_race_not_open": "Selection is closed for this race.",
      "selection_race_started": "This race has started, so the lineup is locked.",
      "selection_season_not_active": "This race belongs to a season that has not started yet.",
      "selection_rider_bound": "This rider is already racing in an overlapping race.",
      "selection_rider_bound_named": "{rider} is already racing {race}, which overlaps. Remove them there, or pick someone else.",
      "selection_flag_disabled": "Team selection isn't active yet.",
      "selection_invalid_body": "Couldn't save the selection. Try again.",
      "selection_wrong_pool": "You can only enter races in your own division.",
      "selection_withdrawn_locked": "You withdrew your team. The field is locked after the first stage.",
      "selection_withdrawn": "You've withdrawn from this race, so a lineup can't be saved for it.",
      "selection_train_now_locked": "Riders who trained today can't be added to or removed from today's race.",
      "selection_youth_squad_train_only": "This squad is set to Train only. Switch it to Enter races on the squad page to enter it.",
      "selection_duplicate_race": "Couldn't save: the same race was included twice. Try again.",
      "selection_bulk_too_large": "You can save at most {max} changed races at once. Save some now, then the rest.",
      "race_not_found": "This race no longer exists. Refresh and try again.",
      "strategy_invalid_body": "Couldn't save your strategy: invalid data.",
      "strategy_flag_disabled": "The race hub isn't active yet.",
      "generic": "Couldn't save the selection. Try again.",
      "saveAllPartial": "These lineups weren't saved: {races}. Your changes are still here, so try saving again."
    }
  },
  "intention": {
    "title": "Race day intention",
    "help": "The role runs all race. The intention is what you want from him on the stage you have open.",
    "helpRaceDay": "The role runs all race. The intention is what you want from him on race day.",
    "colRider": "Rider",
    "colRole": "Role",
    "colIntention": "Intention · stage {number}",
    "colIntentionRaceDay": "Intention · race day",
    "allRace": "All race",
    "thisRace": "This race",
    "stage": "Stage {number}",
    "stageToday": "Stage {number} · today",
    "stageAria": "Intentions for stage {number}",
    "stageTodayAria": "Intentions for stage {number}, today",
    "stageLower": "stage {number}",
    "raceDay": "Race day",
    "raceDayLower": "race day",
    "roleFree": "Free role",
    "notSetNote": "Not set means he rides his role's default.",
    "roleDefault": "Role default · normal",
    "listAnd": " and ",
    "roleDefaultTag": "Role default",
    "nothingSet": "Nothing set. He rides his role.",
    "setIntention": "Set intention",
    "change": "Change",
    "close": "Close",
    "appliesToStageOnly": "Applies to this stage only",
    "pickerTitle": "{name} · {scope}",
    "line": "Default {role}. Today: {today}.",
    "riderAbandoned": "Out of the race",
    "copyToStage": "Copy to stage {number}",
    "save": "Save stage {number}",
    "saveRaceDay": "Save race day",
    "saving": "Saving…",
    "saved": "Intentions saved.",
    "unsaved": "You have unsaved changes",
    "footer": "Stage {stage}: {set, plural, one {# rider} other {# riders}} set, {onDefault} on their role default",
    "footerRaceDay": "Race day: {set, plural, one {# rider} other {# riders}} set, {onDefault} on their role default",
    "footerUntouchedOne": "stage {stages} untouched",
    "footerUntouchedMany": "stages {stages} untouched",
    "step": {
      "grupetto": "Grupetto",
      "save": "Ride easy",
      "normal": "Normal",
      "protect": "Work or attack",
      "all_out": "All out"
    },
    "whyItt": {
      "save": "He rides alone at an easy pace and saves his legs for the days that count."
    },
    "todayItt": {
      "save": "ride easy"
    },
    "why": {
      "grupetto": "Rides it home in the back group. No shot at a result.",
      "save": "Sits in and saves legs for the days that count.",
      "normal": "His normal race.",
      "protect": "Spends himself for the captain. Real fatigue.",
      "all_out": "Everything on today. The hardest day on his legs."
    },
    "today": {
      "grupetto": "grupetto",
      "save": "sit in the bunch",
      "normal": "his normal race",
      "protect": "work or attack",
      "all_out": "all out"
    },
    "byRole": {
      "protect": {
        "work": { "step": "Work", "why": "Rides for the leader. Real fatigue.", "today": "works for the leader" },
        "follow": { "step": "Follow the moves", "why": "Answers every attack. Costs more legs.", "today": "follows the moves" },
        "free": { "step": "Ride aggressively", "why": "Presses on the climbs and in the finale.", "today": "rides aggressively" }
      }
    },
    "roleWord": {
      "captain": "captain",
      "sprint_captain": "sprint captain",
      "co_captain": "shared captain",
      "helper": "rider",
      "hunter": "hunter",
      "free_role": "free role",
      "luxury_helper": "luxury helper"
    },
    "errors": {
      "stage_roles_invalid_body": "Couldn't save the intentions. Try again.",
      "stage_roles_stage_locked": "One of the changes is on a stage that has already started, so it can't be saved.",
      "stage_roles_rider_not_entered": "One of the riders isn't entered in this race.",
      "stage_roles_invalid_role": "One of the roles isn't valid.",
      "stage_roles_invalid_effort": "One of the intentions isn't valid.",
      "stage_roles_role_overlap": "Only one rider can be captain, only one can be sprint captain, and only one can be breakaway hunter, per stage.",
      "stage_roles_co_captain_requires_captain": "A shared captain needs a captain on the same stage.",
      "stage_roles_duplicate": "The same rider appears twice for the same stage.",
      "stage_roles_rider_abandoned": "One of the riders is out of the race and can't be given an intention anymore.",
      "stage_roles_race_completed": "This race is finished, so the intentions can't be changed anymore.",
      "generic": "Couldn't save the intentions. Try again.",
      "stage_roles_conflict": "Your tactics were changed in another window. The latest version is loaded. Check it and save again.",
      "team_orders_grupetto_with_break": "A rider on Grupetto cannot try the break.",
      "team_orders_grupetto_with_train": "A rider on Grupetto cannot ride in the sprint train.",
      "team_orders_work_with_break": "A rider who works for the leader cannot try the break.",
      "team_orders_train_with_break": "A rider in the sprint train cannot try the break."
    }
  },
  "tacticsOrders": {
    "blocked": { "notWithGrupetto": "Not with Grupetto.", "notWithWork": "A rider who works for the leader cannot join the break.", "notWithBreak": "Not while he tries the break.", "notWithTrain": "The sprint train stays in the bunch for the finale." },
    "pickOne": "Pick one",
    "timeTrialNoRoadOrders": "Time trials are ridden against the clock. Breakaway, lead-out and attack orders do not apply here, so they are hidden. Your effort choices still count.",
    "title": "Tactics",
    "locksAt": "Locks {time}",
    "locked": "Locked",
    "lockedNote": "Orders are locked for this stage. They were set at the stage start.",
    "empty": "Save your lineup above to set tactics for it.",
    "planLabel": "Team plan",
    "breakawayLabel": "Breakaway",
    "effortLabel": "Effort",
    "plan": {
      "noCaptain": "No captain set yet. Set your lineup above.",
      "chase": "{captain} leads. The team rides to bring back the breakaway.",
      "neutral": "{captain} leads. The team reads the race as it unfolds.",
      "letGo": "{captain} leads. The team lets the early move go."
    },
    "breakawayAria": "Team breakaway stance",
    "ordersGc": {
      "rulesLabel": "Race rules",
      "rulesName": "Break orders and GC reaction",
      "rulesHelp": "How they work",
      "stanceLabel": "Chasing the break",
      "stance": {
        "chase": "Chase",
        "neutral": "Read the race",
        "let_go": "Leave the chase to others"
      },
      "gcNote": "The team can make a limited response to a serious GC threat with its free riders.",
      "breakNote": "Captain, sprint captain and domestique only go for the morning break with Try the break selected."
    },
    "breakaway": {
      "chase": "Chase it down",
      "neutral": "Neutral",
      "let_go": "Let it go"
    },
    "effort": {
      "protect": "Protect",
      "normal": "Normal",
      "save": "Save",
      "grupetto": "Grupetto",
      "all_out": "All out"
    },
    "effortAria": "Effort for {name}",
    "tryBreak": "Try the break",
    "tryBreakAria": "{name} tries for the breakaway",
    "roleLabel": {
      "captain": "Captain",
      "co_captain": "Shared captain",
      "sprint_captain": "Sprint captain",
      "hunter": "Breakaway hunter",
      "helper": "Domestique",
      "free_role": "Free role",
      "luxury_helper": "Luxury helper"
    },
    "save": "Save tactics",
    "saving": "Saving…",
    "saved": "Tactics saved.",
    "leadout": "Sprint train",
    "leadoutAria": "{name} rides in the sprint train",
    "standardPrefix": "Standard: {role}",
    "todayPrefix": "Today: {today}",
    "today": {
      "ridesRole": "rides their role",
      "tryBreak": "goes for the break",
      "stayInBunch": "stays in the bunch",
      "joinTrain": "rides the sprint train",
      "leaveTrain": "out of the sprint train",
      "effort": {
        "protect": "protects",
        "normal": "normal effort",
        "save": "saves",
        "grupetto": "rides the grupetto",
        "all_out": "gives everything"
      }
    },
    "riderFallback": "Rider",
    "loadError": "Could not load your tactics for this stage.",
    "retry": "Try again",
    "saveError": "Could not save. Try again.",
    "roleDefault": {
      "captain": "protected captain",
      "sprint_captain": "sprint captain",
      "hunter": "breakaway hunter",
      "helper": "domestique",
      "free_role": "free role",
      "luxury_helper": "luxury helper"
    }
  },
  "stageOrders": {
    "title": "Your orders",
    "roleDefaults": "nothing saved, so each rider rode his role",
    "stanceAuto": "Automatic",
    "roleDefaultShort": "role's default"
  },
  "racePage": {
    "tabsAria": "Race sections",
    "tab": {
      "overview": "Overview",
      "team": "Team",
      "tactics": "Tactics",
      "stages": "Stages",
      "results": "Results"
    },
    "hero": {
      "stageLabel": "Stage",
      "stagesLabel": "Stages",
      "terrain": "Terrain",
      "selected": "Selected",
      "locks": "Locks",
      "stageLocks": "Stage {number} locks",
      "yourBest": "Your best",
      "stageWins": "Stage wins",
      "finishers": "Finishers",
      "notStarted": "Not started",
      "nextStageSub": "Next stage",
      "racingNow": "Racing now",
      "allRidden": "All ridden",
      "squadLockedIn": "Squad locked in",
      "squadFrozen": "Squad frozen",
      "abandons": "{count, plural, one {# abandon} other {# abandons}}",
      "chipNextStage": "Next: stage {number} · {time}",
      "chipStageOnRoad": "Stage {number} on the road",
      "chipRacing": "On the road",
      "chipFinished": "Finished",
      "chipStartsAt": "Starts {time}",
      "chipNotStarted": "Not started"
    },
    "stages": {
      "emptyTitle": "No route yet",
      "emptyHint": "The route for this race has not been drawn up yet. It shows up here as soon as it has."
    },
    "tactics": {
      "title": "Tactics",
      "help": "The role runs all race. The intention and the orders are what you want on the stage you have open.",
      "helpScoped": "You choose which stages a role applies to. The intention and the orders are what you want on the stage you have open.",
      "helpRaceDay": "The role runs all race. The intention and the orders are what you want on race day.",
      "colOrders": "Orders · stage {number}",
      "colOrdersRaceDay": "Orders · race day",
      "colRouteMatch": "Route match · stage {number}",
      "colRouteMatchRaceDay": "Route match · race day",
      "sortRouteMatch": "Sort by route match for this stage",
      "saveStatus": {
        "partialTitle": "Only part of the plan was saved",
        "conflictTitle": "Your tactics were changed in another window",
        "roles": "Roles and intentions",
        "orders": "Orders",
        "saved": "Saved",
        "notSaved": "Not saved",
        "keptNote": "Your choices are still here. Save the rest when you are ready.",
        "conflictNote": "Your choices are still here. Load the new version, or keep yours and save them over it.",
        "saveMissing": "Save the rest",
        "loadNew": "Load the new one",
        "keepMine": "Keep mine"
      },
      "stageMeta": "Stage {number} · locks {time}",
      "sprintTrainRiders": "{count, plural, =0 {No one} one {# rider} other {# riders}} for {name}",
      "sprintTrainNone": "No sprint captain in this team.",
      "locked": "Locked",
      "lockedStage": "Stage {number} locked at {time}. This is what you sent them out with.",
      "lockedStageNoTime": "Stage {number} is locked. This is what you sent them out with.",
      "lockedRaceDay": "Race day is locked. This is what you sent them out with.",
      "whatYouSet": "What you set. Stage {number}: {today}.",
      "whatYouSetRaceDay": "What you set. Race day: {today}.",
      "loadError": "Could not load your tactics for this race.",
      "changeRoleAria": "Change {name}'s role",
      "rolePickerTitle": "{name}'s role",
      "roleScope": "From stage {number} to the end of the race",
      "roleScopeRaceDay": "For this race",
      "roleScopeLabel": "Applies to",
      "roleScopeRest": "Stage {number} to the end of the race",
      "roleScopeStageOnly": "Stage {number} only",
      "roleExclusiveNote": "One captain, one sprint captain and one breakaway hunter at a time. The rider who held the role becomes a domestique.",
      "roleExclusiveNoteScoped": "One captain, one sprint captain and one breakaway hunter at a time. The rider who held the role becomes a domestique on the same stages. Earlier stages keep their roles.",
      "roleWhy": {
        "captain": "The team rides for him and he gets the protection.",
        "co_captain": "Protected like the captain. The captain gets help first.",
        "sprint_captain": "He gets the sprint train and the lead out.",
        "hunter": "He goes hunting for the breakaway.",
        "helper": "He works for the leaders.",
        "free_role": "He rides his own race.",
        "luxury_helper": "He saves himself, then works for the captain on the decisive climb. Change the climb in the stage plan."
      }
    },
    "team": {
      "title": "Team",
      "riderCount": "{count, plural, one {# rider} other {# riders}}",
      "duringNote": "The squad is frozen. This is who is riding, and the role you gave him.",
      "afterNote": "Nothing to change any more. This is what you sent them out with, stage by stage.",
      "legend": "Gold is what you chose. Grey is the role's default, which you left alone.",
      "loadError": "Could not load your team for this race.",
      "noRiders": "You have no riders in this race.",
      "gc": "GC",
      "stageShort": "St {number}",
      "dnf": "DNF",
      "jerseyShortcutNote": "{name} leads the general classification but isn't your captain.",
      "jerseyShortcutAction": "Make captain",
      "jerseyShortcutSaving": "Saving…",
      "jerseyShortcutError": "Could not save. Try again."
    },
    "overview": {
      "gap": "Gap",
      "latest": "Latest from the road",
      "whereYouStand": "Where you stand",
      "whereYouStandHelp": "General classification after stage {done}. Stage {running} is still on the road.",
      "whereYouStandHelpOneDay": "The race is on the road.",
      "noStandingsYet": "No classification yet. It shows up when the first stage is in.",
      "topOf": "Top 6 of {count}",
      "today": "Today · stage {number}",
      "howItEnded": "How it ended",
      "howItEndedHelp": "Final general classification.",
      "otherClassifications": "Points, mountains and team classifications are in Results.",
      "openResults": "Open results",
      "latestStageResultHint": "See who won stage {number} and how it played out.",
      "latestStageResultCta": "Stage {number} result",
      "raceIsDone": "Nothing left to set. The race is done.",
      "beforeFlag": "Before the flag",
      "beforeFlagHelp": "What is still open on this race.",
      "nextDecision": "Your next decision",
      "nextDecisionHelp": "The stages you can still set tactics for.",
      "stageTactics": "Stage {number} tactics",
      "raceDayTactics": "Race day tactics",
      "somethingSet": "Set",
      "nothingSet": "Nothing set",
      "nothingLeft": "Nothing left to set on this race.",
      "nothingSetNote": "Nothing set means they ride their roles.",
      "setStageTactics": "Set stage {number} tactics",
      "setRaceDayTactics": "Set race day tactics",
      "check": {
        "teamPicked": "Team picked",
        "rolesSet": "Roles set for the race",
        "firstStage": "Tactics for stage 1",
        "laterStages": "Stages {from}–{to}"
      },
      "checkValue": {
        "picked": "{count, plural, one {# rider} other {# riders}}",
        "rolesDone": "Captain set",
        "laterStages": "Open until each stage locks"
      }
    }
  },
  "strategy": {
    "title": "Team strategy",
    "subtitle": "Standing preferences your assistant uses to build every lineup.",
    "open": "Team strategy",
    "save": "Save strategy",
    "saved": "Strategy saved",
    "regenerate": "Regenerate suggestions",
    "aChain": {
      "title": "A-chain",
      "help": "Your core riders, ranked. They get priority for your target races.",
      "add": "Add rider",
      "empty": "No core riders yet. Add the riders you build around.",
      "up": "Move up",
      "down": "Move down",
      "remove": "Remove"
    },
    "roleRules": {
      "title": "Fixed roles",
      "help": "Lock a rider to a role whenever they're selected.",
      "none": "No fixed role",
      "always_captain": "Always captain",
      "always_sprint_captain_if_present": "Always sprint captain (if selected)"
    },
    "captains": {
      "title": "Captains by terrain",
      "help": "Ranked captain candidates per terrain. The assistant picks the highest-ranked selected rider.",
      "suggest": "Auto-suggest",
      "rank": "Captain {n}",
      "empty": "No candidates yet"
    },
    "buckets": {
      "flat": "Flat",
      "hilly": "Hilly",
      "mountain": "Mountains",
      "cobbles": "Cobbles",
      "itt": "Time trial"
    },
    "targets": {
      "title": "Target races",
      "help": "Mark the races that matter most. Your A-chain is prioritized here.",
      "marked": "Target",
      "empty": "No upcoming races."
    },
    "preview": {
      "title": "How your strategy changes selections",
      "run": "Preview changes",
      "none": "No changes to upcoming auto-filled races.",
      "summary": "{changedRaces} races change · +{totalAdded}/−{totalRemoved} riders · {captainChanges} captain changes",
      "in": "In",
      "out": "Out",
      "captain": "Captain → {name}"
    },
    "error": {
      "title": "Something went wrong",
      "loadTitle": "Team strategy could not be loaded",
      "loadBody": "Nothing was lost. Your saved strategy is safe.",
      "session": "Your session has ended. Sign in again to keep planning.",
      "retry": "Try again"
    }
  },
  "discoverCta": {
    "title": "Pick your race squad",
    "bodyStage": "{race} is coming up. Choose your riders, captain and tactics before the start.",
    "bodyOneDay": "{race} is coming up. Choose your riders, captain and tactics before the start.",
    "action": "Set your line-up"
  },
  "raceCentre": {
    "title": "Race Centre",
    "subtitle": "Today's racing, from first countdown to final result.",
    "navLabel": "Race Centre",
    "stageLabel": "Stage {number} of {total}",
    "oneDayLabel": "One day race",
    "divisionLabel": "Div {tier} pool {pool}",
    "state": {
      "live": "Live",
      "upcoming": "Upcoming",
      "finished": "Finished"
    },
    "card": {
      "yourRider": "Your rider",
      "yourBest": "Your best: {rank} {rider}",
      "liveNoFilm": "The stage is under way. Results land as soon as the riders cross the line.",
      "playbackProgress": "Stage playback progress",
      "lineupReady": "Line-up ready, {selected} of {max} riders picked.",
      "lineupIncomplete": "Line-up incomplete, {selected} of {max} riders picked.",
      "lineupUnknown": "Line-up status is not available for this race.",
      "withdrawn": "Withdrawn from this race.",
      "noResults": "No results have been published for this stage yet."
    },
    "action": {
      "watchLive": "Watch live",
      "reviewTactics": "Review tactics",
      "watchFilm": "Watch the race film",
      "fullResult": "Full result",
      "viewRace": "View race"
    },
    "yours": {
      "title": "Your races today",
      "emptyTitle": "No races for your team today",
      "emptyBody": "Your next race day is on the calendar. Check the planning hub to line up your squad."
    },
    "divisions": {
      "title": "Around the divisions"
    },
    "error": {
      "title": "Today's races could not be loaded",
      "body": "Nothing was lost. Your line-ups and results are safe.",
      "retry": "Try again"
    }
  },
  "detail": {
    "loadError": {
      "message": "Couldn't load the race. Nothing was lost. Try again.",
      "stageMessage": "Couldn't load this stage's results. Nothing was lost. Try again.",
      "retry": "Try again"
    },
    "stat": {
      "status": "Status",
      "stages": "Stages",
      "season": "Season",
      "nextStage": "Next stage"
    },
    "backToLibrary": "Race library",
    "back": "Back",
    "raceDnaLabel": "This race:",
    "terrainDna": {
      "label": "Terrain DNA · what the stage rewards",
      "rest": "Other factors",
      "finaleFactor": "+ up to ±{pct}%: descending & positioning decide the finale"
    },
    "ability": {
      "climbing": "Climbing",
      "time_trial": "Time trial",
      "sprint": "Sprint",
      "punch": "Punch",
      "endurance": "Endurance",
      "cobblestone": "Cobbles",
      "acceleration": "Acceleration",
      "recovery": "Recovery",
      "tactics": "Tactics",
      "positioning": "Positioning",
      "flat": "Flat",
      "tempo": "Tempo",
      "durability": "Durability",
      "aggression": "Aggression",
      "descending": "Descending"
    },
    "tabOverall": "Overall",
    "tabStage": "Stage {number}",
    "noOverall": "No overall classifications recorded",
    "tableResult": "Result",
    "jerseysAfterStage": "Jerseys after the stage",
    "liveStandings": {
      "title": "Standings after stage {number}",
      "note": "The race is still in progress. Standings update after each stage."
    },
    "stageFinishOrder": "Stage {number} · finish order",
    "noResults": "No results",
    "passages": {
      "title": "Intermediate results",
      "kom": "KOM",
      "sprint": "Intermediate sprint",
      "category": "cat. {cat}",
      "points": "{count} pts",
      "bonus": "+{count}s"
    },
    "classification": {
      "gc": "Overall (GC)",
      "points": "Points classification",
      "mountain": "Mountains classification",
      "young": "Young rider",
      "team": "Team classification"
    },
    "classTab": {
      "ariaLabel": "Classification",
      "stage": "Stage",
      "gc": "Overall",
      "points": "Points",
      "mountain": "Mountain",
      "young": "Youth",
      "team": "Teams"
    },
    "teamFilter": {
      "label": "Team",
      "all": "All teams",
      "mine": "My team"
    },
    "showAll": "Show all {count}",
    "showLess": "Hide",
    "team": {
      "winner": "Winner"
    },
    "youBadge": "You",
    "finalKm": {
      "title": "The Final Kilometre",
      "replay": "Replay",
      "distanceKm": "{value} km",
      "distanceM": "{value} m",
      "secondsToGo": "{count} sec to go",
      "finishLine": "Finish",
      "photoFinish": "Photo finish",
      "moreFinishers": "{count, plural, one {+ # more finisher} other {+ # more finishers}}",
      "winType": {
        "sprint_win": "Bunch sprint",
        "close_win": "Close finish",
        "solo_win": "Solo victory",
        "itt_win": "Fastest time",
        "ttt_win": "Fastest team time"
      }
    },
    "film": {
      "storyTitle": "The story of the stage",
      "watchButton": "Watch the race film",
      "title": "Race film",
      "km": "km {value}",
      "gapCurveTitle": "Lead over the chase",
      "gapNow": "Lead {gap}",
      "scrubberLabel": "Scrub through the stage",
      "replay": "Replay",
      "play": "Play",
      "pause": "Pause",
      "feedEmpty": "Scrub forward to see what happened.",
      "split": {
        "title": "Split times",
        "lossTitle": "Where your riders lost time",
        "showAll": "Show all groups",
        "front": "Front",
        "riders": "{count, plural, one {# rider} other {# riders}}",
        "yours": "Yours: {names}",
        "more": "{count, plural, one {# more group further back} other {# more groups further back}}",
        "group": {
          "breakaway": "Breakaway",
          "peloton": "Peloton",
          "group": "Group"
        },
        "drop": "{rider} lost contact with {from, select, breakaway {the breakaway} peloton {the peloton} other {{count, plural, one {his group} other {their group}}}}{where, select, climb { on {place}} sector { on {place}} other {}}.",
        "reason": {
          "climb_deficit": "The pace on the climb was too high for {count, plural, one {him} other {them}}.",
          "wprime_depleted": "{count, plural, one {He} other {They}} had run out of strength.",
          "mixed": "The pace was too high, and some in the group had run out of strength.",
          "grupetto": "{count, plural, one {He was} other {They were}} set to ride in the grupetto.",
          "cobbles_sector": "The cobbles split the group."
        },
        "order": {
          "save": "Your order: Ride easy.",
          "grupetto": "Your order: Grupetto.",
          "plan": "Your order: {task}."
        }
      },
      "event": {
        "stage_start": "{count} riders roll out for {distance} km.",
        "stage_start_itt": "{count} riders go off one by one over {distance} km against the clock.",
        "stage_start_ttt": "The teams go off one by one over {distance} km against the clock.",
        "breakaway_formed": "{riders} {count, plural, one {goes} other {go}} clear off the front.",
        "kom_passage": "{name} (cat. {category}): {rider} leads over the top.",
        "intermediate_sprint": "{name}: {rider} takes the intermediate sprint.",
        "breakaway_caught": "{riders} {count, plural, one {is} other {are}} caught by the pursuing group.",
        "breakaway_caught_by_teams": "{riders} {count, plural, one {is} other {are}} caught. {teamCount, plural, =1 {{teamLast}} other {{teamsHead} and {teamLast}}} did the chasing.",
        "breakaway_caught_by_peloton": "{riders} {count, plural, one {is} other {are}} caught by the peloton.",
        "breakaway_survived": "The breakaway holds off the bunch all the way to the line.",
        "cause": {
          "unchased": "Nobody wanted to chase, so the break got all the room it needed.",
          "no_chasers": "The teams that wanted to chase had no riders left to do it.",
          "own_riders_ahead": "{teamCount, plural, =1 {{teamLast} never chased: it had} other {{teamsHead} and {teamLast} never chased: they had}} riders in the break.",
          "reaction_spent": "{teamCount, plural, =1 {{teamLast} had spent what it could} other {{teamsHead} and {teamLast} had spent what they could}} on the chase.",
          "no_free_riders": "{teamCount, plural, =1 {{teamLast} had} other {{teamsHead} and {teamLast} had}} no free riders to chase with.",
          "gc_contained": "{teamCount, plural, =1 {{teamLast} only rode} other {{teamsHead} and {teamLast} only rode}} to protect the GC and let the stage go.",
          "chase_faded_climb": "The chase faded after {climb}, and the gap grew again.",
          "chase_faded": "The chase faded, and the gap grew again.",
          "chase_too_late": "The chase closed in, but ran out of road.",
          "gap_never_closed": "The chase never brought the gap down.",
          "gc_threat": "{teamCount, plural, =1 {{teamLast} chased} other {{teamsHead} and {teamLast} chased}} because {threats} {threatCount, plural, one {was a threat} other {were a threat}} to {rider} in the GC.",
          "closed_on_climb": "The gap came down on {climb}."
        },
        "order": {
          "all_out_stayed_away": "{rider} rode all out on your orders and stayed away to the line.",
          "all_out_held_on_climb": "{rider} rode all out on your orders and stayed with the front over {climb}.",
          "all_out_held_on": "{rider} rode all out on your orders and stayed with the front group."
        },
        "breakaway_dropped": "{riders} {count, plural, one {is} other {are}} dropped from the break.",
        "group_ahead_formed": "{riders} {count, plural, one {goes} other {go}} clear in a group ahead of the peloton.",
        "group_ahead_caught": "The group ahead of the peloton is caught: {riders}.",
        "group_ahead_survived": "The group ahead of the peloton stays away to the line.",
        "group_ahead_dropped": "{riders} {count, plural, one {is} other {are}} dropped from the group ahead of the peloton.",
        "incident": "{kind, select, mechanical {{rider} goes down with a mechanical.} other {{rider} goes down in a crash.}}",
        "incident_crash_time_loss": "{rider} goes down and loses {seconds} sec.",
        "incident_crash_hard": "{rider} goes down hard: {seconds} sec. lost, and {days, plural, one {# day} other {# days}} on the sidelines.",
        "incident_crash_abandon": "{rider}'s race ends in a crash. He is out for {days, plural, one {# day} other {# days}}.",
        "incident_mechanical": "{rider} punctures and loses {seconds} sec.",
        "incident_mechanical_helper": "{rider} punctures, but help is right there. Only {seconds} sec. lost.",
        "incident_protected": "{rider} goes down inside the final kilometres, but keeps the group's time.",
        "favorite_crack": "{rider} cracks and loses contact with the front.",
        "favorite_crack_tt": "{rider} fades in the second half and bleeds time.",
        "all_out_gain": "{rider} goes all out on the last climb and gains time.",
        "all_out_cracked": "{rider} goes all out and runs empty on the last climb.",
        "bad_day_fatigue": "{rider} had a bad day. The hard days before caught up with him.",
        "bad_day_form": "{rider} had a bad day. He was short of form.",
        "bad_day_illness": "{rider} had a bad day. He was feeling ill.",
        "bad_day_rain": "{rider} had a bad day in the rain.",
        "bad_day_wind": "{rider} had a bad day in the wind.",
        "bad_day_heat": "{rider} had a bad day in the heat.",
        "finale_attack": "{rider} attacks in the finale.",
        "ttt_rider_dropped": "{rider} slips off the back of his team.",
        "sprint_decided": "It comes down to the wire between {rider} and the chasers.",
        "sprint_decided_photo": "Photo finish: it comes down to the wire for {rider}.",
        "outside_time_limit": "{count, plural, one {# rider finishes} other {# riders finish}} outside the time limit and {count, plural, one {leaves} other {leave}} the race.",
        "grupetto_saved": "The gruppetto comes home together: {count, plural, one {# rider is} other {# riders are}} saved.",
        "finish": "{rider} takes the stage win.",
        "finish_sprint_win": "{rider} wins the bunch sprint.",
        "finish_close_win": "{rider} takes the stage win.",
        "finish_solo_win": "{rider} solos to the stage win.",
        "finish_itt_win": "{rider} sets the fastest time of the day.",
        "finish_ttt_win": "{rider} leads home the fastest team of the day.",
        "gc_change": "{rider} takes over the overall lead from {previousLeader}.",
        "group_merged": "{riders} {count, plural, one {rejoins} other {rejoin}} a group.",
        "group_merged_many": "{count} riders regroup.",
        "peloton_split": "{riders} {count, plural, one {moves} other {move}} into a separate group.",
        "group_split_many": "{count} riders split into a separate group.",
        "descent_attack": "{riders} {count, plural, one {attacks} other {attack}} on the descent.",
        "descent_attack_many": "{count} riders attack on the descent.",
        "gc_reaction_started": "{rider}'s team starts working to protect his place in the GC.",
        "gc_reaction_started_threat": "{rider}'s team starts working to limit the threat from {threats} in the GC.",
        "gc_reaction_contained": "{rider}'s team stops working. The threat to his place in the GC is under control.",
        "gc_reaction_stopped": "{rider}'s team stops reacting.",
        "gc_reaction_exhausted": "{rider}'s team has spent what it can on the reaction this stage and stops working.",
        "gc_reaction_no_workers": "{rider}'s team sees the threat, but has no free riders in his group to react.",
        "group_merged_batch": "{count} {scope, select, others {other groups} other {groups}} came back together.",
        "peloton_split_batch": "{count} {scope, select, others {other groups} other {groups}} split away.",
        "finale_attack_batch": "{count} {scope, select, others {other riders} other {riders}} attack in the finale.",
        "finale_attack_named_batch": "{riders} attack in the finale.",
        "gc_reaction_batch_started": "{count} {scope, select, others {other teams} other {teams}} reacted.",
        "gc_reaction_batch_contained": "{count} {scope, select, others {other teams} other {teams}} stopped working. The threat is under control.",
        "gc_reaction_batch_stopped": "{count} {scope, select, others {other teams} other {teams}} stopped reacting.",
        "gc_reaction_batch_exhausted": "{count} {scope, select, others {other teams} other {teams}} spent what they could on the reaction this stage and stopped working.",
        "gc_reaction_batch_no_workers": "{count} {scope, select, others {other teams} other {teams}} saw the threat, but had no free riders in the group to react.",
        "gc_context_missing": "The GC standings before this stage are not available, so no team reacts to a GC threat today.",
        "own_riders_ahead": "{rider}'s team does not chase. It has {riders} up the road.",
        "own_riders_ahead_team": "The team of {riders} does not chase. It has {count, plural, one {him} other {them}} up the road."
      }
    },
    "recap": {
      "title": "Race recap",
      "win": "{rider} took the win.",
      "soloWin": "{rider} soloed clear to win by {marginText}.",
      "sprintWin": "{rider} won the sprint.",
      "ittWin": "{rider} set the fastest time.",
      "tttWin": "{rider} led home the fastest team.",
      "breakawaySurvived": "{count, plural, one {A lone rider stayed away to the finish.} other {A #-rider breakaway stayed away to the finish.}}",
      "breakawayCaught": "{count, plural, one {The lone breakaway rider was caught before the line.} other {The breakaway (# riders) was caught before the line.}}",
      "breakawayCaughtByTeams": "{teamCount, plural, =1 {{teamLast}} other {{teamsHead} and {teamLast}}} led the chase and caught the breakaway {where, select, km {with {km} km to go} other {before the line}}.",
      "breakawayCaughtByPeloton": "The peloton caught the breakaway {where, select, km {with {km} km to go} other {before the line}}.",
      "teamDay": "{team} led the team classification with {count} riders in the top 10.",
      "teamWon": "{team} won the team classification.",
      "jerseys": "Jersey leaders: {points} in points, {mountain} in the mountains.",
      "abandon": "{kind, select, crash {{rider} abandoned after a crash.} mechanical {{rider} abandoned with a mechanical.} injury {{rider} did not start: injured.} withdrawal {{rider} climbed off, exhausted.} time_limit {{rider} finished outside the time limit.} illness {{rider} did not start: ill.} other {{rider} abandoned.}}",
      "notableCrash": "{rider} crashed and lost {marginText}.",
      "withdrawalGroup": "{when, select, stage {{count} riders climbed off after the stage, exhausted and far behind.} other {{count} riders climbed off, exhausted and far behind.}}",
      "seeList": "See the list"
    },
    "incidents": {
      "title": "Abandons",
      "crash": "Crash",
      "mechanical": "Mechanical",
      "injury": "Non-starter",
      "illness": "Ill, did not start",
      "withdrawal": "Climbed off, exhausted",
      "time_limit": "Outside time limit",
      "abandoned": "Abandoned",
      "dnf": "DNF",
      "dnfCollapsed": "{count, plural, one {# rider did not finish} other {# riders did not finish}}",
      "dns": "DNS",
      "dnsTitle": "Did not start",
      "dnsCollapsed": "{count, plural, one {# rider did not start} other {# riders did not start}}"
    },
    "why": {
      "title": "The bigger picture",
      "gcTakeover": "{rider} took over the overall lead from {previousLeader}.",
      "finalGc": "Final general classification: {first}, {second} and {third}.",
      "helperShift": "{captain} finished inside the top 5 after {count} teammates gave up their own results to support him.",
      "favoriteOffDay": "{rider} entered the stage as the strongest rider on paper but finished outside the top 15: {reason, select, jour_sans {he had an off day} incident {a crash or mechanical cost him the day} helper_work {he spent himself working for a teammate} other {no clear reason emerged}}.",
      "formPeak": "{rider} arrived in excellent form and delivered on it."
    },
    "storyTags": {
      "tag_jour_sans": {
        "label": "Off day",
        "tooltip": "Had a bad day: his legs just weren't there."
      },
      "tag_peak_day": {
        "label": "Peak",
        "tooltip": "Timed his form to peak for this stage."
      },
      "tag_perfect_peak": {
        "label": "Perfect peak",
        "tooltip": "Won on a stage he specifically peaked for."
      },
      "tag_helper_sacrifice": {
        "label": "Sacrifice",
        "tooltip": "Gave up his own result to work for the team captain."
      },
      "tag_outsider_win": {
        "label": "Outsider",
        "tooltip": "Won without being the strongest rider on paper."
      },
      "tag_favorite_collapse": {
        "label": "Collapse",
        "tooltip": "The stage favourite lost his shot: {reason, select, jour_sans {he had an off day, his legs just weren't there} incident {a crash or mechanical cost him the day} helper_work {he spent himself working for a teammate} other {no clear reason emerged}}."
      },
      "tag_crash_ruined": {
        "label": "Crash",
        "tooltip": "A likely top result was wrecked by a crash or mechanical."
      },
      "tag_aggression_no_cost": {
        "label": "No cost",
        "tooltip": "Attacked and got caught, but it cost him nothing: joining a breakaway never costs extra fatigue or your own placing."
      },
      "tag_saved_effort": {
        "label": "Saved legs",
        "tooltip": "Set to save legs this stage, as chosen on the tactics page."
      },
      "tag_gave_everything": {
        "label": "Gave everything",
        "tooltip": "Set to work at full effort this stage, as chosen on the tactics page."
      }
    },
    "dayformLine": {
      "band_m5": [
        "Worst legs I have had all season.",
        "I was just surviving out there today.",
        "Everything hurt from the very first kilometre.",
        "I have never suffered this much before."
      ],
      "band_m4": [
        "I had a hard day.",
        "Nothing in the legs today.",
        "I was suffering from the first climb.",
        "Not my day. I will be back."
      ],
      "band_m3": [
        "It was a rough day out there.",
        "I could never find my rhythm today.",
        "Nothing about today felt easy.",
        "I fought for every metre today."
      ],
      "band_m2": [
        "Struggled a bit more than usual today.",
        "Legs did not want to cooperate today.",
        "A tough day, had to dig deep.",
        "Nothing came easy for me today."
      ],
      "band_m1": [
        "Legs felt a little flat today.",
        "Not quite there today, small things missing.",
        "A slightly off day, nothing serious.",
        "Felt a touch heavy in the legs today."
      ],
      "band_0": [
        "Just a normal day out there.",
        "Nothing special today, steady as always.",
        "An ordinary day. Nothing to report.",
        "Legs felt about the same as usual."
      ],
      "band_p1": [
        "Felt a bit better than usual today.",
        "Small spark in the legs today.",
        "A decent day, nothing to complain about.",
        "Things clicked a little today."
      ],
      "band_p2": [
        "Legs felt good, easy day out there.",
        "A solid day, everything worked as planned.",
        "I had good energy the whole stage.",
        "Felt strong and comfortable all day."
      ],
      "band_p3": [
        "I had good legs today.",
        "Today felt like one of my better days.",
        "I was flying a little out there today.",
        "Good day. I could push when it mattered."
      ],
      "band_p4": [
        "I felt strong today.",
        "Legs were good today, boss.",
        "I had it today. There was more to give.",
        "Good day. The body answered every time."
      ],
      "band_p5": [
        "Best legs I have had all season.",
        "I could have gone twice as far today.",
        "Everything I tried today just worked.",
        "I have never felt this strong before."
      ]
    },
    "report": {
      "title": "Stage {number} report",
      "numbers": {
        "margin": "Winning margin",
        "field": "Riders at the start",
        "breakaway": "In the breakaway"
      },
      "headline": {
        "sprint_win": {
          "v1": "{rider} takes the sprint",
          "v2": "{rider} is fastest in the bunch sprint",
          "v3": "The sprint goes to {rider}"
        },
        "itt_win": {
          "v1": "{rider} sets the fastest time",
          "v2": "Nobody beats {rider} against the clock"
        },
        "ttt_win": {
          "v1": "{rider} leads home the fastest team",
          "v2": "The fastest team time goes to {team}"
        },
        "close_win": {
          "v1": "{rider} wins by {marginText}",
          "v2": "{rider} holds on to win"
        },
        "solo_win": {
          "v1": "{rider} rides away from the field",
          "v2": "Nobody could follow {rider}",
          "v3": "A solo win by {marginText} for {rider}"
        },
        "breakaway_survived": {
          "v1": "The breakaway makes it: {rider} wins",
          "v2": "{rider} wins from the breakaway"
        },
        "gc_takeover": {
          "v1": "{rider} takes the race lead",
          "v2": "New race leader: {rider}"
        },
        "final_gc": {
          "v1": "{rider} wins {race}",
          "v2": "The overall win in {race} goes to {rider}"
        }
      },
      "lede": {
        "bunch_sprint": {
          "v1": "The stage came down to a bunch sprint, and {rider} timed it best for {team}.",
          "v2": "A full field arrived together. In the sprint, {rider} was the fastest man for {team}."
        },
        "reduced_sprint": {
          "v1": "A hard finale split the field, and {rider} won the sprint from the front group for {team}."
        },
        "time_trial": {
          "v1": "Every rider went off alone against the clock. {rider} posted the fastest time of the day for {team}.",
          "v2": "Just the rider, the road and the clock. Nobody went faster than {rider} of {team}."
        },
        "team_time_trial": {
          "v1": "The teams rode the course one by one against the clock. {team} was fastest, with {rider} first across the line."
        },
        "solo": {
          "v1": "{rider} left the field behind and crossed the line alone, {marginText} clear.",
          "v2": "The gap only grew. {rider} took the win for {team} with {marginText} to spare."
        },
        "breakaway": {
          "v1": "The break was never brought back. {rider} finished it off for {team}."
        },
        "generic": {
          "v1": "{rider} won for {team}."
        }
      },
      "beat": {
        "breakaway_caught": {
          "v1": "{count, plural, one {The lone escapee was brought back before the finish.} other {The break of # was brought back before the finish.}}",
          "v2": "{count, plural, one {The field closed down the lone leader in time.} other {The field closed down the # leaders in time.}}"
        },
        "breakaway_caught_by_teams": {
          "v1": "{teamCount, plural, =1 {{teamLast}} other {{teamsHead} and {teamLast}}} led the chase and brought the break back {where, select, km {with {km} km to go} other {before the finish}}."
        },
        "breakaway_caught_by_peloton": {
          "v1": "The peloton brought the break back {where, select, km {with {km} km to go} other {before the finish}}."
        },
        "breakaway_survived": {
          "v1": "{count, plural, one {The lone leader was never caught.} other {The # escapees held the field off all the way to the line.}}"
        },
        "helper_shift": {
          "v1": "{team} committed everything to {captain}: {count, plural, one {one teammate} other {# teammates}} worked to bring him to the front.",
          "v2": "{count, plural, one {A teammate} other {# teammates}} gave up their own chances for {captain} today."
        },
        "form_peak": {
          "v1": "{rider} came in with top form, and it showed.",
          "v2": "Form made the difference for {rider} today."
        },
        "favorite_off_day": {
          "v1": "On paper the strongest rider in this field, {rider} finished outside the top 15."
        },
        "gc_takeover": {
          "v1": "{rider} takes the overall lead from {previousLeader}.",
          "v2": "The overall lead changes hands: {rider} is now in front."
        },
        "team_day": {
          "v1": "It was a day for {team}: {count} riders in the top 10."
        },
        "aggression_no_cost": {
          "v1": "{rider} attacked and got caught, but it cost him nothing. A breakaway attempt never costs extra fatigue or your own placing.",
          "v2": "{rider} tried his luck in the breakaway. Caught before the line, but no worse off for trying."
        },
        "saved_effort": {
          "v1": "{rider} was set to save legs this stage, easing off to keep something in reserve.",
          "v2": "{rider} rode within himself today, saving effort for what's ahead."
        },
        "gave_everything": {
          "v1": "{rider} was set to work at full effort, giving everything for the team today.",
          "v2": "No holding back for {rider} today: full effort, all the way."
        }
      },
      "yourTeam": {
        "title": "Your team",
        "bestResult": "Best placed: {rider}, stage rank {rank}.",
        "inBreak": "{rider} spent the day in the breakaway.",
        "helperWork": "{count, plural, one {A teammate rode} other {# teammates rode}} in service of {captain}.",
        "none": "No riders from your team started this stage.",
        "out": "{kind, select, withdrawal {{rider} climbed off after stage {number}.} time_limit {{rider} finished outside the time limit on stage {number}.} crash {{rider} abandoned after a crash on stage {number}.} injury {{rider} did not start stage {number}: injured.} illness {{rider} did not start stage {number}: ill.} other {{rider} abandoned on stage {number}.}}",
        "ridersLeft": "{count, plural, =0 {You have no riders left.} one {You have # rider left.} other {You have # riders left.}}"
      }
    },
    "jersey": {
      "leader": "Leader",
      "points_day": "Points",
      "mountain_day": "Mountains",
      "young_day": "Youth"
    },
    "breakaway": {
      "label": "Morning breakaway",
      "survived": "stayed away to the finish",
      "caught": "caught",
      "dropped": "dropped from the break",
      "participated": "participated",
      "laterAttack": "Later attack",
      "legacyLabel": "Breakaway"
    },
    "stageProfile": {
      "label": "Terrain",
      "note": "Indicative terrain category based on each stage's difficulty.",
      "sectionTitle": "Stage profile"
    },
    "stageSchedule": {
      "title": "Stage schedule",
      "subtitle": "Each stage runs at a fixed time (Copenhagen).",
      "nextStageLabel": "Next stage",
      "countdownPrefix": "in",
      "countdownDays": "{count, plural, one {# day} other {# days}}",
      "countdownHours": "{count, plural, one {# hour} other {# hours}}",
      "countdownMinutes": "{count, plural, one {# min} other {# min}}",
      "startingNow": "Starting now",
      "stageLabel": "Stage {number}",
      "done": "Done",
      "live": "Live",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "timezoneNote": "Times shown in Copenhagen time (CET/CEST)."
    },
    "profileType": {
      "flat": "Flat",
      "rolling": "Rolling",
      "hilly": "Hilly",
      "mountain": "Mountain",
      "high_mountain": "High mountain",
      "itt": "Time trial",
      "itt_hilly": "Hilly time trial",
      "ttt": "Team time trial",
      "cobbles": "Cobbles",
      "gravel": "Gravel",
      "classic": "Classic",
      "medium_mountain": "Medium mountain"
    },
    "finaleType": {
      "bunch_sprint": "Bunch sprint",
      "reduced_sprint": "Reduced sprint",
      "punch": "Punchy finish",
      "long_climb": "Summit finish",
      "descent": "Downhill finish",
      "solo_tt": "Solo time trial",
      "breakaway": "Breakaway-friendly",
      "flat_sprint": "Flat sprint",
      "uphill_sprint": "Uphill sprint",
      "wall_finish": "Wall finish"
    },
    "finaleTypeHint": {
      "bunch_sprint": "The peloton stays together and the stage is decided in a mass sprint.",
      "reduced_sprint": "A reduced group survives to the line and sprints for the win.",
      "punch": "A short, steep kick near the line rewards a late attack over a pure sprint.",
      "long_climb": "Summit finish: the climb itself is the finish line, opening the biggest time gaps of the day.",
      "descent": "The finish comes after a descent, giving chasers a chance to close back down before the line.",
      "solo_tt": "Every rider starts alone against the clock, no drafting.",
      "breakaway": "Terrain that favours an early escape. Whether it stays away is decided on the road, not here.",
      "flat_sprint": "The stage finishes on flat road and is decided in a sprint.",
      "uphill_sprint": "The last kilometre rises gently, so the sprint rewards riders who can hold their power uphill.",
      "wall_finish": "The finish line sits on a short, very steep wall, where explosive power decides the stage."
    },
    "route": {
      "stats": {
        "km": "KM",
        "elevation": "M",
        "climbs": "CLIMBS"
      },
      "read": {
        "summit": {
          "label": "Summit finish",
          "note": "the climb is the line, no bunch finish"
        },
        "valley": {
          "label": "{km} km descent to the line",
          "note": "chasers can come back"
        },
        "technical": {
          "label": "Technical finale",
          "note": "descending & positioning decide it"
        },
        "long": {
          "label": "Long day",
          "note": "endurance & fatigue amplified"
        },
        "short": {
          "label": "Short day",
          "note": "fatigue damped"
        },
        "cobbles": {
          "label": "{count} cobbled sectors",
          "note": "positioning & power over pavé"
        },
        "gravel": {
          "label": "{count} gravel sectors",
          "note": "handling & power on loose ground"
        }
      },
      "waypoint": {
        "climb": "Category {cat} climb",
        "sprint": "Intermediate sprint",
        "finish": "Finish",
        "kmMark": "km {km}",
        "gradient": "{length} km @ {gradient}%",
        "altitude": "{m} m alt.",
        "afterCrest": "{km} km after the last crest"
      },
      "atStake": "AT STAKE",
      "result": "RESULT",
      "komPoints": "{count} KOM pts",
      "greenPoints": "{count} green pts",
      "bonusSeconds": "+{count}s",
      "sprintMarker": "SPRINT · {points}p · +{bonus}s",
      "finishNote": "FINISH {first} / {second} / {third} s",
      "a11y": {
        "graph": "Elevation profile for stage {number}: {distance} km, {elevation} m of climbing, {climbs} categorised climbs"
      }
    },
    "table": {
      "prizePoints": "Prize points",
      "jerseyPoints": "Jersey points",
      "prizePointsShort": "Prize",
      "jerseyPointsShort": "Jersey"
    },
    "jumpToResults": "See results"
  },
  "history": {
    "loadError": {
      "message": "Could not load the race history. Please try again.",
      "retry": "Try again"
    },
    "backToLibrary": "Race library",
    "editionsCount": "{count, plural, one {# edition} other {# editions}}",
    "editions": "Editions",
    "season": "Season {number}",
    "noResults": "No results",
    "bestRiders": "Best riders",
    "bestRidersSub": "Accumulated across all editions",
    "noResultsYet": "No results yet",
    "statGc": "{count} GC",
    "statStageWins": "{count} stage wins",
    "statTop3": "{count} top-3",
    "noWins": "No wins",
    "accumulatedTitle": "Accumulated points total",
    "accumulatedSub": "Top riders by total points across all editions"
  },
  "browse": {
    "error": {
      "title": "Start lists could not be loaded",
      "body": "This view is read-only, so nothing was lost.",
      "session": "Your session has ended. Sign in again to keep planning.",
      "retry": "Try again"
    },
    "readonly": "Read-only",
    "heading": "{division} · {pool}",
    "headingGeneric": "Start lists",
    "horizonNote": "Start lists open {count} days before each race. Roles, form and fatigue stay hidden.",
    "empty": "No races in this pool on this day.",
    "noEntries": "No start list yet.",
    "grossOnly": "Gross squads only. Roles, form and fatigue hidden.",
    "inDays": "{count, plural, one {in # day} other {in # days}}",
    "opensIn": "{count, plural, one {Opens in # day} other {Opens in # days}}",
    "teamCount": "{count, plural, one {# team} other {# teams}}",
    "division": "Div {n}",
    "poolN": "Pool {n}",
    "divisionPicker": "Division",
    "poolPicker": "Pool",
    "you": "you",
    "unknownTeam": "Unknown"
  },
  "tour": {
    "pickRace": {
      "title": "One column per race today",
      "body": "The chip shows how many riders you have entered out of the slots this race gives you. Ride understaffed and you have no one to work for your leader. Tap a rider to make him captain, sprint captain or breakaway hunter."
    },
    "pickRiders": {
      "title": "Your riders live here",
      "body": "Tap a rider, or drag him onto a race, to enter him. A greyed-out chip is already committed: one rider races once per race day. Auto-fill closes the gaps and keeps what you picked yourself. Nothing counts until you press Save changes."
    },
    "tactics": {
      "title": "Set your preferences once",
      "body": "Team strategy stores the riders you build around, your captains per terrain and the races that matter most. Your assistant reuses it every time it fills a lineup for you. Tactics inside a stage race are set on the race itself."
    }
  },
  "selectionReminder": {
    "title": "Squad selection missing",
    "titleUrgent": "Your team will not start",
    "body": "{count, plural, one {# race starts} other {# races start}} without a full squad.",
    "bodyUrgent": "{count, plural, one {# race is} other {# races are}} below the minimum to start.",
    "picked": "{picked}/{target} picked",
    "deadlinePassed": "deadline passed",
    "in": {
      "minutes": "in {count} min",
      "hours": "in {count}h",
      "days": "in {count, plural, one {# day} other {# days}}"
    }
  }
}
